
import axios from "axios";
import { LocalStorageKey } from "../constants/localStorageKeys";

export async function search(payload: any)
{
  // return httpService.post(`${apis.searchImage.search}?provider_code=${payload?.provider_code}`, payload);

  const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  // return httpService.get(`/vmrs/api/v1/providers?page=0&size=100&sort=desc`);
  return axios.post(`${baseUrl}/vmrs/api/v1/search?provider_code=${payload?.provider_code}`, payload);
}

export async function getProvider(payload?: any)
{

  const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  // return httpService.get(`/vmrs/api/v1/providers?page=0&size=100&sort=desc`);
  return axios.get(`${baseUrl}/vmrs/api/v1/providers`);

}


export async function getImageTypes()
{

  const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  return axios.get(`${baseUrl}/vmrs/api/v1/configs/category/satellite_image_type?with_providers=true`);

}



export async function getFormSearchByImageType(payload?: any)
{

  const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  return axios.get(`${baseUrl}/vmrs/api/v1/form-configs/search-form/key/${payload?.key}`);

}


